import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Translation } from 'react-i18next';

import { Link } from 'react-router-dom';

import OutsideHandler from 'components/common/OutsideHandler';

import './LinksNavigationBar.css';

const LinksNavigationBar = ({ activeLinksPage }) => {
  const { t } = useTranslation();
  const tabsList = [
    {
      name: 'common',
      title: t('Links'),
      hidden: false,
    },
    {
      name: 'social',
      title: t('Social'),
      hidden: false,
    },
    {
      name: 'commerce',
      title: t('Commerce'),
      hidden: false,
    },
    {
      name: 'menu',
      title: t('Menu'),
      hidden: false,
    },
    {
      name: 'location',
      title: t('Locations'),
      hidden: false,
    },
    {
      name: 'music',
      title: t('Music'),
      hidden: true,
    },
    {
      name: 'sliders',
      title: t('Gallery'),
      hidden: true,
    },
    {
      name: 'crypto',
      title: t('Crypto'),
      hidden: true,
    },
    {
      name: 'apps',
      title: t('Apps'),
      hidden: true,
    },
  ];
  const [popupOpen, setPopupOpen] = useState(false);

  return (
    <Translation>
      {(t) => (
        <div className="links-navigation-bar__component">
          {/* Visible Tabs */}
          {tabsList.map(tab => (  
            <Link
              className={`link-item${tab.hidden ? ' hidden' : ''}${activeLinksPage === tab.name ? ' active' : ''}${(tab.name === 'sliders' || tab.name === 'menu') ? ' new' : ''}`}
              to={`/links/${tab.name}`}
            >
              <div className={`icon ${tab.name}`} />
              <div className="text">{tab.title}</div>
            </Link> 
            )  
          )}

          {/* More */}
          <div
            className={`link-item more ${popupOpen ? ' active' : ''}`}
            onClick={() => setPopupOpen(true)}
            role="button"
            tabIndex={-1}
          >
            <div className="icon more" />
            <div className="text">{t("More")}</div>
          </div>

          {/* Popup */}
          {popupOpen &&
            <div className="popup-container">
              <OutsideHandler handleClickOutside={() => setPopupOpen(false)}>
                {tabsList.filter(tab => tab.hidden).map(tab => (
                  <Link
                    className={`popup-item${tab.hidden ? ' hidden' : ''} ${tab.name === 'sliders' ? ' new' : ''}`}
                    to={`/links/${tab.name}`}
                    onClick={() => setPopupOpen(false)}
                  >
                    <div className={`icon ${tab.name}`} />
                    <div className="text">{tab.title}</div>
                  </Link>
                ))}
              </OutsideHandler>
            </div>
          }

        </div>
      )}
    </Translation>
  );
};

LinksNavigationBar.propTypes = {
  activeLinksPage: PropTypes.string.isRequired,
};

LinksNavigationBar.defaultProps = {

};

export default LinksNavigationBar;
